import AutoAwesomeIcon from "@mui/icons-material/AutoAwesomeOutlined";
import Box from "@mui/material/Box";
import type { FC } from "react";

/** The advisor's round spark avatar (Figma "Advisor": 26px in the thread, 30px in the mobile header). */
export const AdvisorAvatar: FC<{ size?: number }> = ({ size = 26 }) => (
	<Box
		aria-hidden
		sx={{
			width: size,
			height: size,
			flexShrink: 0,
			borderRadius: "50%",
			display: "grid",
			placeItems: "center",
			bgcolor: "brand.avatarTint",
			color: "primary.main"
		}}>
		<AutoAwesomeIcon sx={{ fontSize: size * 0.55 }} />
	</Box>
);
